import { CompactNumber } from "@/shared/ui/CompactNumber";
import { Card, CardContent } from "@/components/ui/card";
import {
  ArrowDownLeftIcon,
  ArrowUpRightIcon,
  BookOpenIcon,
  ScaleIcon,
} from "lucide-react";

type LedgerSummaryCardsProps = {
  totalCredit: number;
  totalDebit: number;
  auditCoverage: number;
  netBalance: number;
  isLoading?: boolean;
};

export function LedgerSummaryCards({
  totalCredit,
  totalDebit,
  auditCoverage,
  netBalance,
  isLoading,
}: LedgerSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <ArrowDownLeftIcon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ລວມເງິນເຂົ້າ</p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={totalCredit} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-rose-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-rose-500/10">
            <ArrowUpRightIcon className="size-5 text-rose-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ລວມເງິນອອກ</p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={totalDebit} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-blue-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-blue-500/10">
            <BookOpenIcon className="size-5 text-blue-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ການຄຸ້ມຄອງ Audit</p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={auditCoverage} />
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-border bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-slate-500/10">
            <ScaleIcon className="size-5 text-slate-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ຍອດສຸດທິ</p>
            <p className="font-semibold text-2xl tabular-nums">
              <CompactNumber value={netBalance} />
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
